

























import { Component, Vue } from 'vue-property-decorator';
import { Mutation } from 'vuex-class';
import Auth from '@aws-amplify/auth';
import API from '@aws-amplify/api';
import Mixin from '../mixin';

@Component
export default class VerifyEmail extends Mixin {
  private code: string = '';

  @Mutation private signIn!: (user: any) => void;
  @Mutation private setCognito!: (cognitouser: any) => void;

  private mounted() {
    (this.$el.querySelector('#code') as HTMLInputElement).focus();
  }

  private async verify(event: any) {
    event.target.disabled = true;
    try {
      if (this.code.length < 1) {
        this.msg('コードを入力してください');
        (this.$el.querySelector('#code') as HTMLInputElement).focus();
        return;
      }
      await Auth.verifyCurrentUserAttributeSubmit('email', this.code);
      this.msg('メールアドレスの確認ができました!');
      await this.updateUser();
      this.$router.go(-1);
    } catch (ex) {
      this.msg(ex);
      (this.$el.querySelector('#code') as HTMLInputElement).focus();
    } finally {
      event.target.disabled = false;
    }
  }

  private async resend(event: any) {
    if (event.target.disabled) {
      return;
    }
    event.target.disabled = true;
    try {
      await Auth.verifyCurrentUserAttribute('email');
      this.msg('メールを送信しました');
    } catch (ex) {
      this.msg(ex);
    } finally {
      event.target.disabled = false;
    }
  }

  private async updateUser() {
    try {
      const userInfo = await API.post('api', '/user', {
        headers: {Authorization: (await Auth.currentSession() as any).idToken.jwtToken },
      });
      this.signIn(userInfo);
      this.setCognito(await Auth.currentAuthenticatedUser({bypassCache: true}));
    } catch (ex) {
      this.msg(ex);
    }
  }

}
